import { Form, Row, Col, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import {
  VendorFormData,
  vendorSchema
} from 'pages/pages/authentication/card/model';
import {
  updateVendorDetails,
  VendorProfileUpdate
} from 'api/user/vendor_requests';
import toast from 'react-hot-toast';
import { updateProfileDetails } from 'redux-state/user/vendorSlice';
import { useEffect } from 'react';

interface VendorProps {
  showMOdal: boolean;
  setShowModal: (value: boolean) => void;
  vendorData?: VendorFormData;
  vendor?: VendorProfileUpdate;
}

const EditVendor = ({ showMOdal, setShowModal, vendor }: VendorProps) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<VendorFormData>({
    resolver: zodResolver(vendorSchema)
  });

  useEffect(() => {
    if (vendor) {
      reset({
        fullName: vendor.fullName || '',
        email: vendor.email || '',
        phone: vendor.phone || '',
        address: {
          street: vendor.address?.street || '',
          city: vendor.address?.city || '',
          state: vendor.address?.state || '',
          country: vendor.address?.country || '',
          postalCode: vendor.address?.postalCode || '',
          phone: vendor.address?.phone || '' // <- don't forget this if your schema requires it
        }
      });
    }
  }, [vendor, reset]);

  const onSubmit = async (data: VendorFormData) => {
    try {
      const response = await updateVendorDetails(data);
      updateProfileDetails(response);
      toast.success('successfully Upadate Your Profile');
      setShowModal(false);
      window.location.reload();
    } catch (error) {
      toast.error('failed to submit');
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
      <Row className="gy-4">
        <Col md={6}>
          <Form.Group>
            <Form.Label className="fw-semibold fs-9 text-start mb-1">
              Full Name
            </Form.Label>
            <Form.Control
              {...register('fullName')}
              className="rounded-3 ms-2"
            />
            {errors.fullName && (
              <div className="text-danger small ms-2">
                {errors.fullName.message}
              </div>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label className="fw-semibold fs-9 text-start mb-1">
              Email
            </Form.Label>
            <Form.Control
              type="email"
              {...register('email')}
              className="rounded-3 ms-2"
            />
            {errors.email && (
              <div className="text-danger small ms-2">
                {errors.email.message}
              </div>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label className="fw-semibold fs-9 text-start mb-1">
              Phone
            </Form.Label>
            <Form.Control {...register('phone')} className="rounded-3 ms-2" />
            {errors.phone && (
              <div className="text-danger small ms-2">
                {errors.phone.message}
              </div>
            )}
          </Form.Group>
        </Col>
      </Row>

      <h5 className="mt-5 mb-3 border-bottom pb-2 text-dark fw-semibold">
        Address
      </h5>

      <Row className="gy-4">
        <Col md={6}>
          <Form.Group>
            <Form.Label className="fw-semibold fs-9 text-start mb-1">
              Street
            </Form.Label>
            <Form.Control
              {...register('address.street')}
              className="rounded-3 ms-2"
            />
            {errors.address?.street && (
              <div className="text-danger small ms-2">
                {errors.address.street.message}
              </div>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label className="fw-semibold fs-9 text-start mb-1">
              City
            </Form.Label>
            <Form.Control
              {...register('address.city')}
              className="rounded-3 ms-2"
            />
            {errors.address?.city && (
              <div className="text-danger small ms-2">
                {errors.address.city.message}
              </div>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label className="fw-semibold fs-9 text-start mb-1">
              State
            </Form.Label>
            <Form.Control
              {...register('address.state')}
              className="rounded-3 ms-2"
            />
            {errors.address?.state && (
              <div className="text-danger small ms-2">
                {errors.address.state.message}
              </div>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label className="fw-semibold fs-9 text-start mb-1">
              Country
            </Form.Label>
            <Form.Control
              {...register('address.country')}
              className="rounded-3 ms-2"
            />
            {errors.address?.country && (
              <div className="text-danger small ms-2">
                {errors.address.country.message}
              </div>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label className="fw-semibold fs-9 text-start mb-1">
              Postal Code
            </Form.Label>
            <Form.Control
              {...register('address.postalCode')}
              className="rounded-3 ms-2"
            />
            {errors.address?.postalCode && (
              <div className="text-danger small ms-2">
                {errors.address.postalCode.message}
              </div>
            )}
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-3 mt-5">
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          Save
        </Button>
      </div>
    </Form>
  );
};

export default EditVendor;
